import './LoadingSpinner.css';

function LoadingSpinner() {
  return (
    <div className="spinner-overlay">
      <div className="spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-text">Processing...</div>
      </div>
    </div>
  );
}

export default LoadingSpinner;
